export default "__VITE_ASSET__BXvgBmMz__"